<template>
  <div class="verification-page is-progress-bar"
       :class="{'in-progress': progressActive}">
    <router-link v-if="showButtonBack"
                 :to="{name: 'ServerWizardEnterPhone'}"
                 class="verification-page__back-link">
      {{ $gettext('Back') }}
    </router-link>
    <verification v-if="showMainVerification"
                  :onboarding="true"
                  @verify="verifyUser" />
    <failed-verification v-else
                         :failed-reason="currentStatus"
                         @verify="verifyUser" />
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex';
  import Verification from '@/components/shared_components/bankVerification/Verification';
  import FailedVerification from '@/components/shared_components/bankVerification/FailedVerification';
  import constants from '@/modules/constants';

  export default {
    components: {
      verification: Verification,
      'failed-verification': FailedVerification
    },
    data() {
      return {
        isOnboarding: false,
        progressActive: true
      };
    },
    computed: {
      ...mapGetters('UserInfoStore', [
        'userUid',
        'userIsInterpreter',
        'folkeregisterConsentStatus',
        'isBankIdVerificationSource'
      ]),
      ...mapGetters('FeatureFlagsStore', ['enableFolkeregister']),
      ...mapState('UserInfoStore', {
        verificationCreated: ({mainUserInfo}) => mainUserInfo.identityVerificationCreated
      }),
      title() { return this.$gettext('Verify your identity'); },
      description() { return this.$gettext('You need to verify your identity in order to proceed. BankID verification ensures secure access and protects your personal and account information.'); },
      contactUsText() { return this.$gettext('Don\'t have Norwegian BankID?'); },
      actionButtonText() { return this.$gettext('Verify via BankID'); },
      showMainVerification() {
        const excludedStatuses = ['failed', 'failed-not-matched', 'failed-linked-with-other-account'];
        return !excludedStatuses.includes(this.currentStatus);
      },
      currentStatus() { return this.$route.query.verificationStatus; },
      showButtonBack() { return this.isOnboarding && this.userIsNotInterpreter; }
    },
    watch: {
      verificationCreated() {
        if (this.verificationCreated) {
          this.goToDashboard();
        }
      }
    },
    methods: {
      verifyUser() {
        const baseUrl = constants.SECURE_PATH.replace(/\/+$/, '');
        const url = `${baseUrl}/criipto-login?redirectUrl=https://${this.$getString('rootPath', process.env.NODE_ENV)}${this.$route.fullPath}`;
        window.location.href = url;
      },
      goToDashboard() {
        if (this.enableFolkeregister && this.userIsInterpreter && this.folkeregisterConsentStatus === 'unanswered' && this.isBankIdVerificationSource) {
          this.$router.replace(this.$makeRoute({name: 'ServerWizardFolkeregister'}));
        } else if (this.userIsInterpreter) {
          this.$router.replace(this.$makeRoute({name: 'ServerHome'}));
        } else {
          this.$router.replace(this.$makeRoute({name: 'BuyerHome'}));
        }
      }
    },
    mounted() {
      if (localStorage.getItem('onboarding')) {
        this.isOnboarding = localStorage.getItem('onboarding');
      }
      if (this.userUid) {
        this.$store.dispatch('UserInfoStore/fetchUserInfo', this.userUid).then(() => {
          this.progressActive = false;
          if (this.verificationCreated) {
            this.goToDashboard();
          }
        });
      }
    }
  };
</script>

<style src="@/assets/css/bank_verification.css"></style>

<style>
.verification-page {
  padding: 0;
  box-shadow: none;
}

.verification-page__back-link {
  align-self: flex-start;
  padding-left: 15px;
  background: url(~@assets/imgs/arrows/arrow_to_left_black.svg) no-repeat 0 50% / 16px auto;
  font-size: 14px;
}
</style>
